// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"bVgJp":[function(require,module,exports,__globalThis) {
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("react-dom/client");
var _premiumRoot = require("./components/premium_root");
var _withNonAuthedTrpcClient = require("../../misc/with-non-authed-trpc-client");
const initialData = window.__INITIAL_DATA__;
const rootElement = document.getElementById("root");
const isDev = rootElement?.getAttribute("data-environment") === "development";
const App = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _withNonAuthedTrpcClient.WithNonAuthedTrpcClient), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _premiumRoot.PremiumRoot), {
            data: initialData
        })
    });
if (isDev) {
    const root = (0, _client.createRoot)(rootElement);
    root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)(App, {}));
} else (0, _client.hydrateRoot)(rootElement, /*#__PURE__*/ (0, _jsxRuntime.jsx)(App, {}));

},{"react/jsx-runtime":"dpQXr","react-dom/client":"i3gF3","./components/premium_root":"7EMur","../../misc/with-non-authed-trpc-client":"c0i33"}],"7EMur":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PremiumRoot", ()=>PremiumRoot);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _dashboardContainer = require("../../../dashboard/forms/improved_components/base_components/dashboard_container");
var _pricingTable = require("../../../dashboard/forms/improved_components/premium_page/pricing_table");
var _simpleContactModal = require("./simple-contact-modal");
var _staticContainer = require("../../components/static-container");
var _premiumHeader = require("./premium-header");
var _seshToaster = require("../../../dashboard/forms/improved_components/sesh_toaster");
var _gifFeatureSections = require("./gif-feature-sections");
var _featureComparisonTable = require("./feature-comparison-table");
var _customBotCard = require("./custom-bot-card");
function PremiumRoot(props) {
    const [showContactModal, setShowContactModal] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seshToaster.SeshToaster), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _staticContainer.StaticContainer), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dashboardContainer.DashboardContainer), {
                    size: "xl",
                    title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _premiumHeader.PremiumHeader), {}),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pricingTable.PricingTable), {
                            current_pricing: props.data,
                            link_type: "anchor"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gifFeatureSections.GifFeatureSections), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureComparisonTable.FeatureComparisonTable), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "mt-16",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customBotCard.CustomBotCard), {
                                onContactClick: ()=>setShowContactModal(true)
                            })
                        })
                    ]
                })
            }),
            showContactModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _simpleContactModal.SimpleContactModal), {
                onClose: ()=>setShowContactModal(false)
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","react":"IMRgT","../../../dashboard/forms/improved_components/base_components/dashboard_container":"9WDu5","../../../dashboard/forms/improved_components/premium_page/pricing_table":"iyQuU","./simple-contact-modal":"1ki67","../../components/static-container":"i1pQv","./premium-header":"lJLtX","../../../dashboard/forms/improved_components/sesh_toaster":"ja211","./gif-feature-sections":"1o5nb","./feature-comparison-table":"cs05g","./custom-bot-card":"lWy2J","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"i1pQv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StaticContainer", ()=>StaticContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _staticNavbar = require("../../dashboard/forms/improved_components/StaticNavbar");
var _withNonAuthedTrpcClient = require("../../misc/with-non-authed-trpc-client");
var _footer = require("./footer");
function StaticContainer(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex min-h-screen flex-col",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _withNonAuthedTrpcClient.WithNonAuthedTrpcClient), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _staticNavbar.StaticNavbar), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "p-8 sm:p-0"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "flex-grow",
                    children: props.children
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "p-8"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footer.Footer), {})
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","../../dashboard/forms/improved_components/StaticNavbar":"lITN2","../../misc/with-non-authed-trpc-client":"c0i33","./footer":"1yG4P","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"c0i33":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WithNonAuthedTrpcClient", ()=>WithNonAuthedTrpcClient);
var _jsxRuntime = require("react/jsx-runtime");
var _reactQuery = require("@tanstack/react-query");
var _trpc = require("../dashboard/utils/trpc");
var _client = require("@trpc/client");
var _react = require("react");
function WithNonAuthedTrpcClient(props) {
    const [queryClient] = (0, _react.useState)(()=>new (0, _reactQuery.QueryClient)());
    const [trpcClient] = (0, _react.useState)(()=>(0, _trpc.trpc).createClient({
            links: [
                (0, _client.httpBatchLink)({
                    url: "/trpc"
                })
            ]
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trpc.trpc).Provider, {
        client: trpcClient,
        queryClient: queryClient,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactQuery.QueryClientProvider), {
            client: queryClient,
            children: props.children
        })
    });
}

},{"react/jsx-runtime":"dpQXr","@tanstack/react-query":[["QueryClient","jC0Ps"],["QueryClientProvider","dHYz4"]],"../dashboard/utils/trpc":"dyYvM","@trpc/client":"98Zm4","react":"IMRgT","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"1yG4P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Footer", ()=>Footer);
parcelHelpers.export(exports, "DesktopFooter", ()=>DesktopFooter);
parcelHelpers.export(exports, "MobileFooter", ()=>MobileFooter);
var _jsxRuntime = require("react/jsx-runtime");
function Footer() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(DesktopFooter, {
                className: "is-hidden-mobile"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(MobileFooter, {
                className: "is-hidden-tablet"
            })
        ]
    });
}
function DesktopFooter(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("footer", {
        className: `columns is-vcentered ${props.className}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "column is-1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "column is-4",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            className: "white-link is-size-6-desktop is-size-7-tablet",
                            href: "../policies",
                            target: "_blank",
                            children: "Privacy Policy and Terms of Service"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "is-size-6-desktop is-size-7-tablet",
                        children: [
                            "\xa9 Tunks ",
                            new Date().getFullYear()
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "column is-2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "column",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "columns is-multiline",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "column is-narrow",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                    className: "white-link is-size-6-desktop is-size-7-tablet",
                                    href: "mailto: contact@tunks.games",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "icon is-small is-primary",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                className: "fas fa-envelope"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: "contact@tunks.games"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                    className: "white-link is-size-6-desktop is-size-7-tablet",
                                    href: "../time-finder",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "icon is-small is-primary",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                className: "fas fa-users"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: "Group Time Finder"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "column is-1"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "column is-narrow",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                    className: "is-size-6-desktop is-size-7-tablet white-link",
                                    href: "https://roadmap.sesh.fyi",
                                    target: "_blank",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "icon is-small is-primary",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                className: "fas fa-map"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: "Roadmap"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                    className: "white-link is-size-6-desktop is-size-7-tablet",
                                    href: "../timestamp",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "icon is-small is-primary",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                className: "far fa-clock"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: "Timestamp Converter"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
function MobileFooter(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("footer", {
        className: `columns is-mobile is-vcentered is-multiline is-mobile ${props.className}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "column is-full",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "columns is-multiline is-mobile",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "column is-1"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "column is-5",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                    className: "white-link is-size-7",
                                    href: "mailto: contact@tunks.games",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "icon is-small is-primary",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                className: "fas fa-envelope"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: "contact@tunks.games"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                    className: "white-link is-size-7",
                                    href: "../time-finder",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "icon is-small is-primary",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                className: "fas fa-users"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: "Group Time Finder"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "column is-5",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "is-pulled-right",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                        className: "is-size-7 white-link",
                                        href: "https://roadmap.sesh.fyi",
                                        target: "_blank",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "icon is-small is-primary",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                    className: "fas fa-map"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "Roadmap"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                        className: "white-link is-size-7",
                                        href: "../timestamp",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "icon is-small is-primary",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                    className: "far fa-clock"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "Timestamp Converter"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "column is-1"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "column is-full"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "column is-full has-text-centered",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            className: "white-link is-size-7",
                            href: "../policies",
                            target: "_blank",
                            children: "Privacy Policy and Terms of Service"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "is-size-7",
                        children: [
                            "\xa9 Tunks ",
                            new Date().getFullYear()
                        ]
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lJLtX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PremiumHeader", ()=>PremiumHeader);
var _jsxRuntime = require("react/jsx-runtime");
function PremiumHeader() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "mx-auto max-w-4xl",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "relative border-2 border-sesh-primary/20 bg-base-dark px-8 py-10 text-center shadow-lg transition-all duration-300 hover:border-sesh-primary/30",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "absolute -top-5 left-1/2 -translate-x-1/2 bg-base-dark px-6",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "text-xl uppercase tracking-widest text-sesh-primary",
                        children: "Premium"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    className: "mb-2 text-6xl font-black uppercase tracking-tight text-sesh-primary",
                    children: "Unlock the full power"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                    className: "text-4xl font-black text-sesh-primary",
                    children: [
                        "of ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "sesh-title font-extrabold",
                            children: "sesh"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "mx-auto mt-6 h-1 w-32 bg-sesh-primary/30 transition-all duration-300 group-hover:w-48 group-hover:bg-sesh-primary/50"
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"dpQXr","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"lIuHI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"52Uq9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_assertThisInitialized);
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"kg9va":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inheritsLoose);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, _setPrototypeOfJsDefault.default)(t, o);
}

},{"./setPrototypeOf.js":"6RWgQ","@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"6RWgQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"5mymf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_getPrototypeOf);
function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}],"2OdDn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isNativeReflectConstruct);
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"kMaoF"}]},["bVgJp"], "bVgJp", "parcelRequire7ff5", {})

//# sourceMappingURL=premium.d43481ac.js.map
